<div class="directory-toolbar">
  <mat-form-field appearance="outline" subscriptSizing="dynamic" class="search">
    <mat-label>Name oder E-Mail</mat-label>
    <mat-icon matPrefix>search</mat-icon>
    <input matInput [(ngModel)]="search" autocomplete="off">
  </mat-form-field>

  <mat-form-field appearance="outline" subscriptSizing="dynamic">
    <mat-label>Team</mat-label>
    <mat-select [(ngModel)]="teamFilter">
      <mat-option [value]="null">Alle Teams</mat-option>
      <mat-option value="none">Ohne Team ({{ withoutTeamCount }})</mat-option>
      <mat-option *ngFor="let team of filterTeams" [value]="team.id">{{ team.name }}</mat-option>
    </mat-select>
  </mat-form-field>

  <mat-form-field appearance="outline" subscriptSizing="dynamic">
    <mat-label>Skill</mat-label>
    <mat-select [(ngModel)]="skillFilter">
      <mat-option [value]="null">Alle Skills</mat-option>
      <mat-option *ngFor="let skill of filterSkills" [value]="skill.id">
        {{ skill.name }}<ng-container *ngIf="skill.ownerTeamName"> (Team {{ skill.ownerTeamName }})</ng-container>
      </mat-option>
    </mat-select>
  </mat-form-field>

  <mat-button-toggle-group *ngIf="store.canEditProfiles" [(ngModel)]="statusFilter" aria-label="Planungsstatus">
    <mat-button-toggle value="planning" matTooltip="Mitarbeiter der Gesamtplanung (über Team oder manuell aufgenommen)">
      In der Gesamtplanung ({{ inPlanningCount }})
    </mat-button-toggle>
    <mat-button-toggle value="none" matTooltip="Benutzerkonten, die aktuell nicht in der Ressourcenplanung enthalten sind">
      Nicht in der Planung ({{ notInPlanningCount }})
    </mat-button-toggle>
    <mat-button-toggle value="all" matTooltip="Alle Benutzerkonten">Alle Konten</mat-button-toggle>
  </mat-button-toggle-group>
</div>

<div class="directory-sub">
  <span class="result-count">
    {{ employees.length }} {{ employees.length === 1 ? 'Mitarbeiter' : 'Mitarbeiter' }}
    <button mat-button *ngIf="hasFilters" (click)="resetFilters()">Filter zurücksetzen</button>
  </span>
  <div class="directory-actions" *ngIf="store.canManagePlanningMembers">
    <span class="legend">
      <span class="badge planning-team"><mat-icon>groups</mat-icon>über Team</span>
      <span class="badge planning-manual"><mat-icon>person_pin</mat-icon>manuell</span>
      <span class="badge muted"><mat-icon>visibility_off</mat-icon>nicht in der Planung</span>
    </span>
    <button mat-flat-button color="primary" [disabled]="store.busy" (click)="openAddDialog()"
      matTooltip="Bestehende Benutzerkonten unabhängig von Teams in die Gesamtplanung aufnehmen">
      <mat-icon>person_add</mat-icon> Zur Gesamtplanung hinzufügen
    </button>
  </div>
</div>

<p class="hint info" *ngIf="!store.isGlobal">
  <mat-icon>info_outline</mat-icon>
  Du siehst die Mitglieder der Teams, die du leitest.
</p>

<div class="table" role="table" aria-label="Mitarbeiter" *ngIf="employees.length">
  <div class="row head" role="row">
    <span role="columnheader">Mitarbeiter</span>
    <span role="columnheader">Teams</span>
    <span role="columnheader">Gesamtplanung</span>
    <span role="columnheader">Skills</span>
    <span role="columnheader" class="num">Wochenstunden</span>
  </div>

  <button type="button" class="row" role="row" *ngFor="let p of employees; trackBy: trackProfile"
    [class.selected]="p.userId === selectedUserId" [class.outside]="!p.isInPlanning" (click)="openProfile.emit(p.userId)">
    <span class="cell person" role="cell">
      <span class="avatar">{{ p.name.charAt(0).toUpperCase() }}</span>
      <span class="person-text">
        <strong>{{ p.name }}</strong>
        <small>{{ p.email || 'Keine E-Mail' }}</small>
        <span class="badges">
          <span class="badge leader" *ngIf="isLeader(p)"><mat-icon>verified_user</mat-icon>Teamleitung</span>
        </span>
      </span>
    </span>

    <span class="cell teams" role="cell">
      <ng-container *ngIf="p.memberships.length; else noTeam">
        <span class="team-tag" *ngFor="let m of p.memberships" [class.primary]="m.teamId === p.primaryTeamId"
          [matTooltip]="m.teamId === p.primaryTeamId ? 'Hauptteam' : ''">
          <mat-icon *ngIf="m.teamId === p.primaryTeamId">star</mat-icon>
          <mat-icon *ngIf="m.isLeader && m.teamId !== p.primaryTeamId">verified_user</mat-icon>
          {{ m.teamName }}
        </span>
        <span class="badge warn" *ngIf="p.memberships.length > 1 && !p.primaryTeamId">Hauptteam fehlt</span>
      </ng-container>
      <ng-template #noTeam><span class="badge muted">Keinem Team zugeordnet</span></ng-template>
    </span>

    <span class="cell planning" role="cell" [ngSwitch]="planningSource(p)">
      <span class="planning-status">
        <span class="badge planning-team" *ngSwitchCase="'team'"
          matTooltip="Automatisch in der Gesamtplanung, weil Mitglied eines aktiven Teams">
          <mat-icon>groups</mat-icon>über Team
        </span>
        <span class="badge planning-manual" *ngSwitchCase="'manual'"
          matTooltip="Manuell aufgenommen – unabhängig von Teams">
          <mat-icon>person_pin</mat-icon>manuell
        </span>
        <ng-container *ngSwitchCase="'both'">
          <span class="badge planning-team" matTooltip="Automatisch in der Gesamtplanung, weil Mitglied eines aktiven Teams">
            <mat-icon>groups</mat-icon>über Team
          </span>
          <span class="badge planning-manual" matTooltip="Zusätzlich manuell aufgenommen – bleibt auch ohne Team in der Gesamtplanung">
            <mat-icon>person_pin</mat-icon>manuell
          </span>
        </ng-container>
        <span class="badge muted" *ngSwitchCase="'none'" matTooltip="Aktuell nicht in der Ressourcenplanung enthalten">
          <mat-icon>visibility_off</mat-icon>nicht in der Planung
        </span>
      </span>
      <span class="planning-actions" *ngIf="store.canManagePlanningMembers" (click)="$event.stopPropagation()">
        <button mat-icon-button *ngIf="!p.isManuallyPlanned" [disabled]="store.busy" (click)="addToPlanning(p, $event)"
          [matTooltip]="p.isPlannedByTeam ? 'Zusätzlich manuell aufnehmen (bleibt auch ohne Team in der Gesamtplanung)' : 'Zur Gesamtplanung hinzufügen'"
          [attr.aria-label]="p.name + ' zur Gesamtplanung hinzufügen'">
          <mat-icon>person_add</mat-icon>
        </button>
        <button mat-icon-button *ngIf="p.isManuallyPlanned" [disabled]="store.busy" (click)="removeFromPlanning(p, $event)"
          [matTooltip]="p.isPlannedByTeam ? 'Manuelle Aufnahme aufheben (bleibt über Team in der Gesamtplanung)' : 'Aus der Gesamtplanung entfernen'"
          [attr.aria-label]="p.name + ' aus der Gesamtplanung entfernen'">
          <mat-icon>person_remove</mat-icon>
        </button>
      </span>
    </span>

    <span class="cell skills" role="cell">
      <span class="skill-chip" *ngFor="let skill of skillsOf(p) | slice:0:4">
        <span class="skill-dot" [style.backgroundColor]="skill.color || '#607d8b'"></span>{{ skill.name }}
      </span>
      <span class="more" *ngIf="skillsOf(p).length > 4">+{{ skillsOf(p).length - 4 }}</span>
      <span class="none" *ngIf="!skillsOf(p).length">–</span>
    </span>

    <span class="cell num" role="cell">
      {{ p.weeklyCapacityHours | number:'1.0-2':'de-AT' }} h
    </span>
  </button>
</div>

<div class="empty" *ngIf="!employees.length">
  <mat-icon>{{ hasFilters ? 'search_off' : 'person_off' }}</mat-icon>
  <ng-container *ngIf="hasFilters">Keine Mitarbeiter passend zu den Filtern.</ng-container>
  <ng-container *ngIf="!hasFilters && statusFilter === 'none'">Alle Benutzerkonten sind in der Gesamtplanung.</ng-container>
  <ng-container *ngIf="!hasFilters && statusFilter !== 'none'">Keine Mitarbeiter vorhanden.</ng-container>
  <button mat-stroked-button color="primary" *ngIf="!hasFilters && statusFilter === 'planning' && store.canManagePlanningMembers"
    (click)="openAddDialog()">
    <mat-icon>person_add</mat-icon> Zur Gesamtplanung hinzufügen
  </button>
</div>
